import { render, staticRenderFns } from "./VSelectComponent.vue?vue&type=template&id=486d392a&"
import script from "./VSelectComponent.vue?vue&type=script&lang=js&"
export * from "./VSelectComponent.vue?vue&type=script&lang=js&"
import style0 from "./VSelectComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports